/* ALVEMORA atelier carousel, progressive enhancement; native scrolling remains functional. */
(()=>{if(window.__alvReviewAtelierReady)return;window.__alvReviewAtelierReady=true;
const setup=(root)=>{
 const track=root.querySelector('.alv-original-track');
 const prev=root.querySelector('[data-alv-reviews-prev]');
 const next=root.querySelector('[data-alv-reviews-next]');
 if(!track||!prev||!next||track.dataset.atelierInit)return;
 track.dataset.atelierInit='true';
 const update=()=>{
  prev.disabled=track.scrollLeft<=3;
  next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;
  const pos=root.querySelector('[data-alv-review-position]');
  const first=track.querySelector('.alv-original-card');
  const total=track.querySelectorAll('.alv-original-card').length;
  if(pos && first && total){
   const step=first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap)||0);
   const index=Math.min(total,Math.max(1,Math.round(track.scrollLeft/Math.max(step,1))+1));
   const pad=n=>String(n).padStart(2,'0');
   pos.innerHTML='<strong>'+pad(index)+'</strong><span aria-hidden="true"> / </span>'+pad(total);
   pos.setAttribute('aria-label','Opinión '+index+' de '+total);
  }
 };
 const go=(direction)=>{
  const first=track.querySelector('.alv-original-card');
  if(!first)return;
  const gap=parseFloat(getComputedStyle(track).gap)||0;
  const distance=first.getBoundingClientRect().width+gap;
  track.scrollBy({left:distance*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 };
 prev.addEventListener('click',()=>go(-1));
 next.addEventListener('click',()=>go(1));
 track.addEventListener('scroll',update,{passive:true});
 window.addEventListener('resize',update,{passive:true});
 update();
};
const boot=(scope=document)=>scope.querySelectorAll('.alv-reviews-section').forEach(setup);
boot();document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
